<template>
  <Card shoaw class="strategy-edit">
    <div class="content">
      <div class="">
        <Row class="title">
          <h4 :style="{float: 'left'}">{{ title }}</h4>
        </Row>
        <Alert v-if="editError" type="warning" show-icon>获取策略数据失败</Alert>
        <Row v-else>
          <Col span="24" :md="{span:22, offset:1}" :xl="{span:14, offset:5}">
            <Form ref="editForm" :model="editForm" :label-width="95" :rules="editRule">
              <FormItem label="策略名称" prop="name">
                <Input v-model="editForm.name" :maxlength="48" placeholder="请填写策略名称" />
              </FormItem>
              <FormItem label="校验类型" prop="style">
                <RadioGroup v-model="editForm.style">
                  <Radio label="config">检测常规配置</Radio>
                  <Radio label="order">检测命令输出</Radio>
                </RadioGroup>
              </FormItem>
              <div v-if="editForm.style === 'config'">
                <FormItem label="配置项" prop="option">
                  <Input v-model="editForm.option" :maxlength="256" placeholder="请填写配置项，如 hostname" />
                </FormItem>
                <FormItem label="校验实时配置" prop="is_real_time">
                  <div style="float: left; margin-right: 15px">
                    <i-switch v-model="editForm.is_real_time">
                      <span slot="open">是</span>
                      <span slot="close">否</span>
                    </i-switch>
                  </div>
                  <Alert style="float: left;" show-icon v-if="editForm.is_real_time">将校验设备实时配置！（耗时相对较长）</Alert>
                  <Alert style="float: left;" show-icon v-else>将校验设备最后一次备份的配置版本，若设备无备份，将校验失败！</Alert>
                </FormItem>
              </div>
              <div v-if="editForm.style === 'order'">
                <FormItem label="命令" prop="cmd">
                  <Input v-model="editForm.cmd" :maxlength="256" placeholder="请填写要执行的命令" />
                </FormItem>
              </div>
              <FormItem label="匹配规则">
                <div v-for="(item, itemIndex) in editForm.rule" :key="itemIndex" style="padding-top: 5px; display: inherit;">
                  <Tag style="float: left; margin-right: 5px;" color="success" class="mob-f-unset">规则 {{ itemIndex + 1 }}</Tag>
                  <Select style="width: 200px; float: left; margin-right: 5px;" placeholder="选择行" v-model="item.line_type" size="small" class="mob-f-unset"
                          v-if="editForm.style === 'order'">
                    <Option value="every" key="every">任意行</Option>
                    <Option value="specify" key="specify">指定行</Option>
                  </Select>
                  <Select style="width: 200px; float: left; margin-right: 5px;" placeholder="选择满足行数" v-model="item.match_line" size="small" class="mob-f-unset"
                          v-if="editForm.style === 'order' && item.line_type === 'every'">
                    <Option value="one" key="one">满足一行即可</Option>
                    <Option value="all" key="all">所有行都必须满足</Option>
                  </Select>
                  <InputNumber :min="1" v-model="item.line_number" size="small" style="width: 200px; float: left; margin-right: 5px;" placeholder="指定行号"
                        v-if="editForm.style === 'order' && item.line_type === 'specify'" class="mob-f-unset"/>
                  <Select style="width: 200px; float: left; margin-right: 5px;" placeholder="字符类型" v-model="item.type" size="small" class="mob-f-unset">
                    <Option v-for="typeItem in typeList" :value="typeItem.value" :key="typeItem.value">{{ typeItem.label }}</Option>
                  </Select>
                  <Select style="width: 200px; float: left; margin-right: 5px;" placeholder="匹配方式" v-model="item.style" size="small" class="mob-f-unset">
                    <Option v-for="styleItem in styleList" :value="styleItem.value" :key="styleItem.value" v-if="styleItem.allowType.indexOf(item.type) > -1">{{ styleItem.label }}</Option>
                  </Select>
                  <Input v-model="item.keyword" size="small" style="width: 200px; float: left;" placeholder="关键字 / 字符长度"
                        v-if="item.style !== 'exist' && item.style !== 'nexist'" class="mob-f-unset"/>
                  <Tooltip :content="'移除规则' + (itemIndex + 1)">
                    <a v-on:click="removeRuleItem(itemIndex)" style="color: #515a6e; margin-left: 10px;"><Icon type="md-close" size="15" style="padding-bottom: 9px"/></a>
                  </Tooltip>
                </div>
                <Row>
                  <a v-on:click="addRuleItem()">添加规则</a>
                </Row>
              </FormItem>
              <FormItem label="描述" prop="desc">
                <Input v-model="editForm.desc" :maxlength="1024" type="textarea" />
              </FormItem>
              <FormItem>
                <div style="float: right">
                  <Button type="primary" @click="changeSubmit">提交</Button>
                  <Button style="margin-left: 8px" @click="getData" v-show="$route.params.id">重置</Button>
                  <Button style="margin-left: 8px" @click="back">取消</Button>
                </div>
              </FormItem>
            </Form>
          </Col>
        </Row>
      </div>
    </div>
  </Card>
</template>

<script>
import { editConfigStrategy, detailConfigStrategy } from '@/api/network'
export default {
  name: 'edit',
  components: {
  },
  data () {
    return {
      editForm: {
        id: this.$route.params.id ? this.$route.params.id : 0,
        name: '',
        style: 'config',
        option: '',
        cmd: '',
        rule: [],
        desc: '',
        is_real_time: false
      },
      editError: false,
      title: this.$route.params.id ? '编辑策略' : '添加策略',
      editRule: {
        name: { required: true, message: '策略名称不能为空', trigger: 'blur' },
        option: { required: true, message: '配置项不能为空', trigger: 'blur' },
        cmd: { required: true, message: '命令不能为空', trigger: 'blur' },
        style: { required: true, message: '校验类型不能为空', trigger: 'change' }
      },
      typeList: [
        { label: '任意字符', value: 'str' },
        { label: '数字', value: 'int' },
        { label: '字符长度', value: 'length' },
        { label: '大写字母', value: 'higher' },
        { label: '小写字母', value: 'lower' },
        { label: '特殊符号', value: 'special' }
      ],
      styleList: [
        { label: '精确等于', value: 'exact', allowType: ['str', 'int', 'length'] },
        { label: '开头等于', value: 'startswith', allowType: ['str'] },
        { label: '结尾等于', value: 'endswith', allowType: ['str'] },
        { label: '包含关键字', value: 'contains', allowType: ['str'] },
        { label: '不包含关键字', value: 'excute', allowType: ['str'] },
        { label: '存在', value: 'exist', allowType: ['str', 'int', 'higher', 'lower', 'special'] },
        { label: '不存在', value: 'nexist', allowType: ['str', 'int', 'higher', 'lower', 'special'] },
        { label: '大于', value: 'gt', allowType: ['int', 'length'] },
        { label: '大于等于', value: 'gte', allowType: ['int', 'length'] },
        { label: '小于', value: 'lt', allowType: ['int', 'length'] },
        { label: '小于等于', value: 'lte', allowType: ['int', 'length'] }
      ]
    }
  },
  watch: {
    '$route' () {
      if (this.$route.params.id) {
        this.getData()
      } else {
        this.editForm = {
          id: this.$route.params.id ? this.$route.params.id : 0,
          name: '',
          style: 'config',
          option: '',
          cmd: '',
          rule: [],
          desc: '',
          is_real_time: false
        }
      }
    }
  },
  created: function () {
    if (this.$route.params.id) {
      this.getData()
    } else {
      this.addRuleItem()
    }
  },
  methods: {
    // 获取脚本数据
    getData () {
      this.editError = false
      detailConfigStrategy(this.$route.params.id).then(res => {
        this.editForm = res.data
      }).catch(res => {
        this.editError = true
        this.$Notice.error({ title: '获取策略数据失败' })
      })
    },
    // 编辑提交
    changeSubmit () {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          let reqData = {
            id: this.editForm.id,
            name: this.editForm.name,
            rule: [],
            desc: this.editForm.desc,
            style: this.editForm.style
          }
          if (this.editForm.style === 'order') {
            reqData.cmd = this.editForm.cmd
          } else {
            reqData.option = this.editForm.option
            reqData.is_real_time = this.editForm.is_real_time
          }
          if (this.editForm.rule.length <= 0) {
            this.$Notice.error({
              title: '请至少添加一条规则！'
            })
            return
          } else {
            let rr = 0
            for (let i in this.editForm.rule) {
              rr++
              let item = this.editForm.rule[i]
              let tRule = {
                style: item.style,
                type: item.type,
                keyword: ''
              }
              if (this.editForm.style === 'order') {
                tRule.line_type = item.line_type
                tRule.line_number = item.line_number
                tRule.match_line = item.match_line
                if (!item.line_type) {
                  this.$Notice.error({ title: `请将规则${rr}填写完整！` })
                  return
                } else if (item.line_type === 'every' && !item.match_line) {
                  this.$Notice.error({ title: `请将规则${rr}填写完整！` })
                  return
                } else if (item.line_type === 'specify' && !item.line_number) {
                  this.$Notice.error({ title: `请将规则${rr}填写完整！` })
                  return
                }
              }
              if (!item.style || !item.type) {
                this.$Notice.error({ title: `请将规则${rr}填写完整！` })
                return
              } else if (item.style !== 'exist' && item.style !== 'nexist') {
                if (!item.keyword) {
                  this.$Notice.error({ title: `请将规则${rr}填写完整！` })
                  return
                } else {
                  tRule.keyword = item.keyword
                }
              }
              reqData.rule.push(tRule)
            }
          }
          editConfigStrategy(reqData, reqData.id).then(res => {
            this.$Notice.success({
              title: '操作成功！'
            })
            this.$router.push({
              name: 'network_strategy_detail',
              params: { id: res.data['id'] }
            })
          }).catch(res => {
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！服务器无响应'
              })
            }
          })
        } else {
          this.$Notice.warning({
            title: '请检查输入框！'
          })
        }
      })
    },
    back () {
      this.$router.go(-1)
    },
    // 移除规则
    removeRuleItem (index) {
      this.editForm.rule.splice(index, 1)
    },
    // 添加规则
    addRuleItem () {
      this.editForm.rule.push({
        line_type: 'every',
        line_number: null,
        match_line: 'one',
        style: '',
        type: '',
        keyword: ''
      })
    }
  }
}
</script>

<style lang="less">
  @import '../../base.less';
  @media screen and (max-width:640px){
    .content .main .info-property dl dt{
      width:105px;
    }
  }
</style>
